<template lang="pug">
    div(
        class="flex flex-wrap justify-between items-center sm:mb-6"
        :class="{'mb-6' : isCategoryFilterAB || !catalogData.showSameDayShippingFacet }"
    )
        //- A/B Category filter test - show old toolbar
        div(v-if="!isCategoryFilterAB"
            class="flex justify-between items-center gap-2"
            :class="{'sm:w-auto' : catalogData.showSameDayShippingFacet, 'w-full' : $device.isSmall}"
        )
            div(
                v-if="$device.isSmall && catalogData.showSameDayShippingFacet"
                class="flex-initial"
            )
                SameDayShippingButton

            div(
                v-if="$device.isSmall && !catalogData.showSameDayShippingFacet"
                class="flex-initial mr-1 grow"
            )
                SearchStats(class="font-bold")

            div(
                v-if="$device.isSmall"
                class="flex-auto"
                :class="{'grow-0': !catalogData.showSameDayShippingFacet }"
            )
                BaseButton(
                    size="SMALL"
                    color="GRAY"
                    buttonStyle="OUTLINE"
                    @click.native="openSortMenu"
                    class="w-full"
                )
                    img(src="@/assets/sort.svg" alt="sort" class="h-2 w-2 mr-2" loading="lazy")
                    | Sort

            div(
                v-if="$device.isSmall"
                class="flex-auto"
                :class="{'grow-0': !catalogData.showSameDayShippingFacet}"
            )
                BaseButton(
                    size="SMALL"
                    color="GRAY"
                    buttonStyle="OUTLINE"
                    @click.native="openFacetMenu"
                    hasCustomPadding
                    class="w-full px-4 py-3 sm:px-6"
                )
                    img(v-if="activeRefinementCount === 0" src="@/assets/filter.svg" alt="filter" class="h-2 w-2 mr-2" loading="lazy")
                    span(v-else class="mr-2 w-[18px] h-[18px] leading-none rounded-full items-center justify-center inline-flex bg-gray-light") {{ activeRefinementCount }}
                    | Filter


        //- A/B Category filter test - show new toolbar on desktop & mobile
        //- ---
        //- Was easier to duplicate the toolbar instead of doing v-if checks on every button
        //- for both desktop & mobile
        div(v-else
            class="flex justify-start items-center gap-2 sm:w-auto"
            :class="{'w-full' : $device.isSmall}"
        )
            div(
                v-if="catalogData.showSameDayShippingFacet"
                class="hidden md:block lg:flex-initial"
            )
                SameDayShippingButton(class="text-sm font-normal")

            div(
                class="flex-auto"
            )
                BaseButton(
                    size="SMALL"
                    color="GRAY_DARKEST"
                    buttonStyle="OUTLINE"
                    @click.native="openFilterSortMenu"
                    class="w-full capitalize"
                )
                    img(src="@/assets/sort.svg" alt="sort" class="h-3 w-3 mr-2" loading="lazy")
                    span(class="font-normal text-sm") Sort

            div(
                class="flex-auto"
            )
                BaseButton(
                    size="SMALL"
                    color="GRAY_DARKEST"
                    buttonStyle="OUTLINE"
                    @click.native="openFilterMenu"
                    class="w-full capitalize"
                )
                    img(v-if="activeRefinementCount === 0" src="@/assets/filter.svg" alt="filter" class="h-3 w-3 mr-2" loading="lazy")
                    span(v-else class="mr-2 w-[18px] h-[18px]  text-sm leading-none rounded-full items-center justify-center inline-flex bg-gray-light") {{ activeRefinementCount }}
                    span(class="font-normal text-sm") All Filters

            //- Might be a better way to check if we should display the Category button here
            div(
                v-if="!$device.isSmall && categoryGroup.values.length > 0"
                class="flex-auto"
            )
                BaseButton(
                    size="SMALL"
                    color="GRAY_DARKEST"
                    buttonStyle="OUTLINE"
                    @click.native="openFilterSubMenu(categoryGroup.title)"
                    class="w-full capitalize"
                )
                    span(class="font-normal text-sm") Category

            template(v-for="facet in catalogData.facets")
                div(
                    v-if="!$device.isSmall && refinements(facet.facet).length > 0"
                    class="flex-auto"
                )
                    BaseButton(
                        size="SMALL"
                        color="GRAY_DARKEST"
                        buttonStyle="OUTLINE"
                        @click.native="openFilterSubMenu(facet.text)"
                        class="w-full capitalize"
                        :class="facet.facet in activeRefinements ? 'border-2' : ''"
                    )
                        span(class="text-sm" :class="facet.facet in activeRefinements ? 'font-bold' : 'font-normal'") {{facet.text}}


        //- A/B Category filter update - do not show search stats in test
        div(
            v-if="!$device.isSmall && !catalogData.showSameDayShippingFacet && !isCategoryFilterAB"
            class="py-4 w-full sm:w-auto sm:order-first sm:py-0 sm:mr-auto"
        )
            SearchStats(class="font-bold w-full text-center")

        div(
            v-if="catalogData.showSameDayShippingFacet && !isCategoryFilterAB"
            class="py-4 w-full sm:w-auto sm:order-first sm:py-0 sm:mr-auto"
        )
            SearchStats(class="font-bold w-full text-center")


        //- A/B Category filter update - do not show sort overlay in test
        SortBy(v-if="!isCategoryFilterAB")

        FilterSlideMenu(
            v-if="isCategoryFilterAB"
            @onToggle="toggleFilterMenu"
            @closeFilterSubMenu="closeFilterSubMenu"
            :showFilterMenu="showFilterMenu"
            :filterSubMenu="filterSubMenu"
            :menuType="menuType"
        )

</template>

<script>
import SearchComponent from '@/components/search/component'
import SearchStats from '@/components/search/stats'
import BaseButton from '@/components/baseButton'
import FilterSlideMenu from '@/components/filterSlideMenu'
import FilterSlideMenuMixin from '@/components/filterSlideMenu/_components/mixins'
import SameDayShippingButton from './sameDayShipping/button'
import SortBy from './sortBy'

export default {
    components: {
        SearchStats,
        BaseButton,
        SameDayShippingButton,
        SortBy,
        FilterSlideMenu,
    },
    extends: SearchComponent,
    mixins: [FilterSlideMenuMixin],
    props: {
        isCategoryFilterAB: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showFilterMenu: false,
            filterSubMenu: null,
            menuType: 'filter',
        }
    },
    computed: {
        catalogData() {
            return this.$store.state.catalog.data
        },
        activeRefinementCount() {
            return this.$searchContext.state.activeRefinementCount
        },
        activeRefinements() {
            return this.$searchContext.state.activeRefinements
        },
    },
    methods: {
        openSortMenu() {
            this.$overlay.show('sortMenu')
        },
        openFacetMenu() {
            this.$overlay.show('facetMenu')
        },
        toggleFilterMenu() {
            this.showFilterMenu = !this.showFilterMenu
        },
        openFilterSubMenu(menu) {
            this.filterSubMenu = menu
            this.openFilterMenu()
        },
        closeFilterSubMenu() {
            this.filterSubMenu = null
        },
        openFilterMenu() {
            this.menuType = 'filter'
            this.toggleFilterMenu()
        },
        openFilterSortMenu() {
            this.menuType = 'sort'
            this.toggleFilterMenu()
        },
        refinements(facet) {
            const refinements = this.$searchContext.state.refinements[facet] || []
            return refinements.filter(({ isValid }) => isValid)
        },
    },
}
</script>
